// extracted by mini-css-extract-plugin
module.exports = {"button":"guest_button__u8nPb","deleteIcon":"guest_deleteIcon__2rmAF"};